
export class LogbookComponentKey {
  static readonly LOGBOOK_TABLE = 'logbook/component/logbook-table';
}
